import React from 'react'
import {withRouter} from 'react-router-dom'
import {ClubChargeProvider} from "./store/useClubChargeContext"
import {ClubChargeLayout} from "./layout"

const ClubCharge = () => {
    return <ClubChargeProvider>
        <ClubChargeLayout></ClubChargeLayout>
    </ClubChargeProvider>
}
export default withRouter(ClubCharge)



// WEBPACK FOOTER //
// ./src/containers/ClubCharge/index.js